

export const ImageContainer = ({ src, alt, caption, style }) => {
    return <div className="image-container">
        <img
            style={style}
            src={src}
            alt={alt}
            className="article-image"
        />
        {caption && <p className="image-caption">{caption}</p>}
    </div>
}